import {css} from 'lit';
export const styles = css`:host {
  /* Header */
  --header-margin: 0;
  --header-padding: 0;
  --header-color: var(--dark-text);
  --header-border-bottom: none;
  --header-border-top: none;
  --header-border-left: none;
  --header-border-right: none;
  --header-items-gap: 16px;

  /* Heading */
  --heading-font-size: var(--font-size-lg);
  --heading-font-weight: 500;

  /* Toggle button */
  --toggle-button-items-gap: 8px;

  /* Icon */
  --icon-font-size: var(--font-size-xl);
  --icon-color: var(--dark-text);

  /* Label */
  --label-font-size: inherit;
  --label-color: inherit;

  display: block;
}

header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: var(--header-margin);
  padding: var(--header-padding);
  color: var(--header-color);
  border-bottom: var(--header-border-bottom);
  border-top: var(--header-border-top);
  border-left: var(--header-border-left);
  border-right: var(--header-border-right);
}

h3 {
  margin-top: 0;
  margin-bottom: 0;
  font-size: var(--heading-font-size);
  font-weight: var(--heading-font-weight);
}

header > button {
  margin-left: var(--header-items-gap);
  display: flex;
  align-items: center;
  border: none;
  color: inherit;
  background-color: transparent;
  transition: opacity var(--transition-timing) var(--transition-duration);
}

@media (hover: hover) {

header > button {
    cursor: pointer
}

    header > button:hover {
      opacity: 0.7;
    }
  }

header > button:active {
    opacity: 0.9;
  }

ef-icon {
  font-size: var(--icon-font-size);
}

ef-icon:not(:first-child) {
    margin-left: var(--toggle-button-items-gap);
  }

.label {
  font-size: var(--label-font-size);
  color: var(--label-color);
}
`;
export default styles;
